import CallAPI from "../../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../../utility/Redux/modal";
import deleteWholeDatabase from "../../../utility/functions/deleteWholeDatabase";
import dataToLocal from "../../../utility/component/dataToLocal";

export const GetSaleSummary = (
  data,
  token,
  dispatch,
  setSummaryList,
  setTotalPages,
  setCurrentPage,
  setOpeningBalDetails
) => {
  dispatch(setSpinnerLoading("Loading..."));
  deleteWholeDatabase("account_ledger");
  CallAPI(
    "/api/accountLedger/accountLedger",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        setOpeningBalDetails({
          CLOSING_BALANCE: e.data.CLOSING_BALANCE,
          CLOSING_BALANCE_TYPE: e.data.CLOSING_BALANCE_TYPE,
        });
        setTotalPages(e.data.pagination.totalPages);
        setCurrentPage(e.data.pagination.page);
        if (e.data.transactions[0]) {
          const transactions = e.data.transactions;
          let list = [];
          let openingBal = e.data.CLOSING_BALANCE;
          const type = e.data.CLOSING_BALANCE_TYPE;
          if (type === "Cr") {
            openingBal = -e.data.CLOSING_BALANCE;
          }

          for (let index = 0; index < transactions.length; index++) {
            const item = transactions[index];
            const bal = openingBal + item.DEBIT - item.CREDIT;
            list.push({
              ...item,
              BALANCE: bal,
            });
            openingBal = bal;
          }
          setSummaryList(list);

          dataToLocal("account_ledger", list, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        } else {
          setSummaryList([]);
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records Found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
